import { getBrightness } from './getBrightness';
import { setSystemBrightness } from './setBrightness';

export const increaseBrightness = async () => {
  const value = await getBrightness();
  return await setSystemBrightness(Math.min(value + 0.2, 1));
};
